module.exports = __webpack_public_path__ + "img/item3.d36eebe7.png";